export enum PartitionType {
  Photo = 0,
  Video = 1,
  Text = 2,
  Phone = 3,
  SocialMedia = 4,
  Gallery = 5,
  Slider = 6,
}
